export const NOTIFICATIONS_QUERY_KEY = ["system", "notifications"];
export const BADGE_COUNT_KEY = "badge-count";
export const TABLE_KEY = "table";
